<template>
    <div v-redirect-if-no-permission:LOCATIONS>
        <DataTable :url="api.ACTIONS.LANDMARKS"
                   :fieldsHiddenMain='["deleted_at","radius","type","polygon"]'
                   :titles="titles"
                   :actionsExtraMain="actionsExtraMain"
                   :formatter="formatter"
                   title="Landmarks"/>
    </div>

</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "LandmarkList",
        title: 'Landmarks',
        components: {DataTable},
        computed: {
            titles() {
                return {
                    "id": "#",
                    "created_at": "Date Created",
                    "updated_at": "Date Updated"
                }
            },
            actionsExtraMain() {
                return {
                    edit: {
                        action: (item) => `/landmarks/${item.id}`
                    },
                    add: {
                        link: `/landmarks/add`
                    }
                };
            },
            formatter() {
                return {
                    centroid(value) {
                        return JSON.stringify(value.coordinates);
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>